webpackJsonp([162898551421021],{

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _components = __webpack_require__(7);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFoundPage = function (_React$Component) {
	  _inherits(NotFoundPage, _React$Component);
	
	  function NotFoundPage(props) {
	    _classCallCheck(this, NotFoundPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      lang: ""
	    };
	    return _this;
	  }
	
	  NotFoundPage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      if (document.documentElement.lang !== "") {
	        _this2.setState({ lang: document.documentElement.lang });
	      }
	    }, 300);
	  };
	
	  NotFoundPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { style: this.props.transition ? this.props.transition.style : { opacity: 0 } },
	      _react2.default.createElement(_components.Head, {
	        source: {
	          meta_title: [{
	            text: "404"
	          }],
	          meta_description: [{
	            text: ""
	          }],
	          social_sharing_image: {
	            url: ""
	          }
	        }
	      }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        this.state.lang !== "" && _react2.default.createElement(
	          _rebass.Box,
	          null,
	          _react2.default.createElement(_components.PageHeader, {
	            title: this.state.lang === "en-us" ? "You may have tried to access a page that doesn't exist yet, or is not available in your language." : this.state.lang === "es-mx" ? "Es posible que haya intentado acceder a una página que aún no existe o que no está disponible en su idioma." : "قد تكون حاولت الوصول إلى صفحة غير موجودة بعد ، أو غير متوفرة باللغة المطلوبة. ",
	            color: "404"
	          }),
	          _react2.default.createElement(
	            _components.PageSection,
	            null,
	            _react2.default.createElement(
	              _components.PageContent,
	              null,
	              _react2.default.createElement(_components.PrimaryButton, {
	                is: _gatsbyLink2.default,
	                to: this.state.lang === "en-us" ? "/" : "/" + this.state.lang + "/",
	                children: this.state.lang === "en-us" ? "Click here to go to our homepage." : this.state.lang === "es-mx" ? "Haga clic aquí para regresar a nuestra página principal." : "اضغط هنا للرجوع الى صفحتنا الرئيسية."
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return NotFoundPage;
	}(_react2.default.Component);
	
	exports.default = NotFoundPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-fae076358857791382e8.js